import { inject } from '@angular/core';
import { map, Observable, switchMap } from 'rxjs';
import { USER_DATA_TOKEN, UserDataProvider, UserModel } from '@core';
import { FeatureFlag } from '../enums';
import { FeatureFlagDto, FeatureFlagsRecord, FeatureFlagsStorage } from '@feature-flags/infra';

export class FeatureFlagHandler {
  private readonly featureFlagsStorage: FeatureFlagsStorage = inject(FeatureFlagsStorage);
  private readonly userDataProvider: UserDataProvider = inject(USER_DATA_TOKEN);

  isEnabled$(flag: FeatureFlag): Observable<boolean> {
    return this.userDataProvider.userData$.pipe(
      switchMap((userData: UserModel) =>
        this.featureFlagsStorage.flags$.pipe(
          map((flags: FeatureFlagsRecord) => {
            const selectedFlag: FeatureFlagDto = flags[flag];

            if (!selectedFlag) return false;

            if (selectedFlag?.isEnabled && !selectedFlag?.users?.length) return true;

            return selectedFlag?.isEnabled && selectedFlag?.users?.includes(userData.userId);
          })
        )
      )
    );
  }
}
